import { Controller } from "@hotwired/stimulus"
import { clearKeyStore } from "../crypto"

export default class extends Controller {
  async logout() {
    // Clear keys from IndexedDB on logout
    await clearKeyStore()
  }
}
